import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class IpoOtpRegisterUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getIpoOtpRegister(req);
    }
}
export default IpoOtpRegisterUseCase;
